export const UPDATE_SPOUSE_DATA = 'UPDATE_SPOUSE_DATA';
export const UPDATE_SPOUSE_ERROR = 'UPDATE_SPOUSE_ERROR';
export const MODEL_SPOUSE_DATA = 'MODEL_SPOUSE_DATA';
export const SET_INITIAL_STATE_FOR_SPOUSE_DATA = 'SET_INITIAL_STATE_FOR_SPOUSE_DATA';
export const DELETE_SPOUSE = 'DELETE_SPOUSE';
export const DELETE_SPOUSE_SUCCESS = 'DELETE_SPOUSE_SUCCESS';
export const DELETE_SPOUSE_ERROR = 'DELETE_SPOUSE_ERROR';

export const updateSpouseData = (data: any) => ({
  type: UPDATE_SPOUSE_DATA,
  payload: data,
});

export const updateSpouseError = (data: any) => ({
  type: UPDATE_SPOUSE_ERROR,
  payload: data,
});

export const modelSpouseData = () => ({
  type: MODEL_SPOUSE_DATA,
});

export const setInitialStateForSpouseData = (data: any) => ({
  type: SET_INITIAL_STATE_FOR_SPOUSE_DATA,
  payload: data,
});

export const deleteSpouse = () => ({
  type: DELETE_SPOUSE,
});

export const deleteSpouseSuccess = (payload: any) => ({
  type: DELETE_SPOUSE_SUCCESS,
  payload,
});
export const deleteSpouseError = (payload: any) => ({
  type: DELETE_SPOUSE_ERROR,
  payload,
});
